module.exports = __webpack_public_path__ + "static/media/Raleway-Light.6c084270.ttf";